<div class="result-block">
    <div class="steps-padding ">
        <div class="d-block d-md-none my-2 text-center">
            <div class="" style="max-width: 45%; margin: 0 auto;">
                <app-result-progress [outerStrokeColor]="'#7d96aa'" [innerStrokeColor]="'#647e92'"
                    [subtitleColor]="'#7d96aa'" [titleColor]="'#7d96aa'" [unitsColor]="'#7d96aa'"
                    [score]="result?.score"></app-result-progress>
            </div>
            <p>YOUR {{categoryData[activeCat]?.name}} SCORE</p>

        </div>

        <h2>
            Your {{categoryData[activeCat]?.name | case}} Assessment Result is <span
                class="text-primary-light">{{result?.grade | case}}</span>
        </h2>
        <div class="row  flex-column-reverse flex-md-row">
            <div class="col-md-12" *ngIf="result.points && result.points.length">
                <ul>
                    <li *ngFor="let point of result.points;">
                        <span class="material-icons">
                            minimize
                        </span>
                        <span>{{point}}</span>
                    </li>
                </ul>
            </div>
            <!-- <div class="col-md-6">
                <div class="text-center text-md-left my-4" *ngIf="result.points && result.points.length">
                    <iframe [src]="result.videoURL | safe: 'resourceUrl'" width="100%" height="260" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                </div>
                <div class="mt-4 d-none d-md-block">
                    <p class="video-finish">Finish watching your result video and continue with the Assessment</p>
                  
                </div>

            </div> -->
        </div>
        <div class="mt-4 d-block d-md-none">
            <!-- <button mat-stroked-button disabled class="video-btn mb-3 text-left">
                <div class="d-flex flex-row align-items-center">
                    <span class="icon-play mr-3">
                        <span class="material-icons">
                            play_arrow
                        </span>
                    </span>
                    <span class="text">Finish watching your result video</span>
                </div>
            </button>
            <p class="video-finish">Finish watching your result video and continue with the Assessment</p> -->
         
        </div>
    </div>

    <div class="actions mt-4">
        <!-- <button mat-stroked-button disabled class="video-btn mr-4 text-left d-none d-md-block">
            <div class="d-flex flex-row align-items-center">
                <span class="icon-play mr-3">
                    <span class="material-icons">
                        play_arrow
                    </span>
                </span>
                <span class="text">Finish watching your result video</span>
            </div>
        </button> -->
        <button *ngIf="!isAssesmentCompleted" mat-flat-button color="primary" class="light-btn" (click)="onClickNext()">
            Next category: {{categoryData[nextCat]?.name}} <span class="material-icons ml-2">
                arrow_right_alt
            </span></button>
        <button *ngIf="isAssesmentCompleted" mat-flat-button color="primary" class="light-btn"
            (click)="onClickFinish()">
            Finish Assessment <span class="material-icons ml-2">
                arrow_right_alt
            </span></button>
    </div>
</div>